import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const SecondBreakfastIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 44 44" {...props}>
      <path
        d="M22.0183 43.646C33.9846 43.646 43.6851 33.9455 43.6851 21.9793C43.6851 10.013 33.9846 0.3125 22.0183 0.3125C10.0521 0.3125 0.351562 10.013 0.351562 21.9793C0.351562 33.9455 10.0521 43.646 22.0183 43.646Z"
        fill="#E8F1FF"
      />
      <path
        d="M22.0168 36.9204C30.2694 36.9204 36.9594 30.2303 36.9594 21.9778C36.9594 13.7252 30.2694 7.03516 22.0168 7.03516C13.7642 7.03516 7.07422 13.7252 7.07422 21.9778C7.07422 30.2303 13.7642 36.9204 22.0168 36.9204Z"
        fill="#F7BA61"
      />
      <path
        d="M6.27929 16.7385C6.24679 17.1317 6.29302 17.5274 6.41527 17.9026C4.17724 18.5256 2.86808 20.8449 3.49109 23.0829C3.81638 24.2515 4.63047 25.2228 5.72417 25.7474C5.53814 26.0948 5.42336 26.4758 5.38647 26.8681C5.28355 28.6451 6.63857 30.1699 8.41533 30.2765C8.91638 30.318 9.4205 30.2497 9.89241 30.0763L12.3512 23.5673L12.3049 18.244L11.2798 14.3701C10.8457 14.1161 10.3611 13.9601 9.86028 13.9129C8.09145 13.7055 6.48895 14.97 6.27929 16.7385Z"
        fill="#C0D36E"
      />
      <path
        d="M36.2159 10.7737C36.2213 9.12851 34.892 7.7905 33.2469 7.78517C32.1517 7.78162 31.1429 8.37923 30.6199 9.34144C26.928 7.46559 22.4145 8.9379 20.5386 12.6298C18.6628 16.3218 20.1351 20.8353 23.827 22.7111C27.519 24.587 32.0325 23.1147 33.9083 19.4227C34.8335 17.602 34.9758 15.4827 34.3025 13.5545C35.4539 13.1124 36.2144 12.0071 36.2159 10.7737Z"
        fill="white"
      />
      <path
        d="M26.5012 19.3657C28.3583 19.3657 29.8637 17.8602 29.8637 16.0032C29.8637 14.1461 28.3583 12.6406 26.5012 12.6406C24.6441 12.6406 23.1387 14.1461 23.1387 16.0032C23.1387 17.8602 24.6441 19.3657 26.5012 19.3657Z"
        fill="#FBB540"
      />
      <path
        d="M15.2926 37.6692C19.4189 37.6692 22.7639 34.3241 22.7639 30.1979C22.7639 26.0716 19.4189 22.7266 15.2926 22.7266C11.1663 22.7266 7.82129 26.0716 7.82129 30.1979C7.82129 34.3241 11.1663 37.6692 15.2926 37.6692Z"
        fill="#C77445"
      />
      <path
        d="M11.5598 23.473C13.2102 23.473 14.5482 22.135 14.5482 20.4846C14.5482 18.8341 13.2102 17.4961 11.5598 17.4961C9.90927 17.4961 8.57129 18.8341 8.57129 20.4846C8.57129 22.135 9.90927 23.473 11.5598 23.473Z"
        fill="#FF6161"
      />
      <path
        d="M12.0148 17.2504C13.6653 17.2504 15.0033 15.9124 15.0033 14.2619C15.0033 12.6114 13.6653 11.2734 12.0148 11.2734C10.3643 11.2734 9.02637 12.6114 9.02637 14.2619C9.02637 15.9124 10.3643 17.2504 12.0148 17.2504Z"
        fill="#FF6161"
      />
      <path
        d="M37.5619 25.0907C37.1493 25.0909 36.8146 24.7566 36.8145 24.344C36.8145 24.3154 36.816 24.2868 36.8193 24.2584L37.2623 20.4048C37.309 19.9948 37.6792 19.7004 38.0892 19.7471C38.2232 19.7623 38.3505 19.8135 38.4577 19.8953L41.8945 22.5102C42.2228 22.76 42.2865 23.2288 42.0366 23.5572C41.944 23.6789 41.816 23.7693 41.6703 23.8161L37.7898 25.0563C37.7162 25.08 37.6393 25.0916 37.5619 25.0907Z"
        fill="#8F563B"
      />
      <path
        d="M24.7527 41.6408C24.5018 41.6407 24.2678 41.5146 24.1296 41.3053L21.9876 38.0711C21.7597 37.727 21.854 37.2634 22.1979 37.0357C22.3099 36.9615 22.4399 36.9188 22.5741 36.9123L26.8872 36.7001C27.2993 36.68 27.6497 36.9978 27.6698 37.41C27.6773 37.5634 27.6372 37.7155 27.5551 37.8454L25.3885 41.2919C25.2534 41.5063 25.0188 41.6377 24.7654 41.6408H24.7527Z"
        fill="#8F563B"
      />
      <path
        d="M16.792 26.4609H18.2864V27.9553H16.792V26.4609Z"
        fill="#E8F1FF"
      />
      <path
        d="M19.0332 28.6992H20.5276V30.1936H19.0332V28.6992Z"
        fill="#E8F1FF"
      />
      <path
        d="M16.792 31.6992H18.2864V33.1936H16.792V31.6992Z"
        fill="#E8F1FF"
      />
      <path
        d="M10.8135 31.6992H12.3078V33.1936H10.8135V31.6992Z"
        fill="#E8F1FF"
      />
      <path
        d="M12.3086 26.4609H13.803V27.9553H12.3086V26.4609Z"
        fill="#E8F1FF"
      />
      <path
        d="M13.8037 33.9375H15.2981V35.4319H13.8037V33.9375Z"
        fill="#E8F1FF"
      />
      <path
        d="M13.8037 29.4453H15.2981V30.9397H13.8037V29.4453Z"
        fill="#E8F1FF"
      />
      <path
        d="M28.3291 38.6166C27.5412 38.6178 26.7936 38.2682 26.2895 37.6625L26.2842 37.6565C25.3303 36.5179 25.4801 34.8215 26.6187 33.8675C26.6872 33.81 26.7587 33.756 26.8326 33.7057L28.5339 32.3168C30.4331 30.7707 31.9775 28.8342 33.0622 26.6386L33.8303 25.0906C34.4437 23.6839 36.0812 23.0408 37.4878 23.6542C38.8945 24.2676 39.5376 25.9051 38.9242 27.3118L37.8991 29.4732C36.5717 32.2665 34.5735 34.6877 32.0827 36.5209L29.8032 38.1922C29.3606 38.4673 28.8503 38.6142 28.3291 38.6166Z"
        fill="#8F563B"
      />
    </SvgIcon>
  );
};

export default SecondBreakfastIcon;
